// eslint-disable-next-line import/prefer-default-export
export const excludeTemplates = ['ppc', 'responsible_gambling_guide'];
